import React from 'react'
import Home from './component/Home'
import Service1 from './component/Service1'
import ServiceLast from './component/ServiceLast'
import Footer from 'component/header/Footer'
import Service5 from './component/Service5'
import Service3 from './component/Service3'
import Service2 from './component/Service2'
import Service4 from './component/Service4'
import Service6 from './component/Service6'
import useScrollAnimation from 'component/useScrollAnimation'

const Ourservice = () => {
  useScrollAnimation();
  return (
    <div>
      <Home/>
      <Service1/>
      <Service2/>
      <Service3/>
      <Service4/>
      <Service5/>
      <Service6/>
      <ServiceLast/>
      <Footer/>
    </div>
  )
}

export default Ourservice
